import {URL_BASE_API } from '../../../configs/urlConfigs';
import {LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP} from '../../../configs/staticConfigs';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';

import service from '../../api';

let userGroup = ''; 

export const clientCategoryList = (request) => {
    let userGroupData = userGroupUrlCheck(window.location);
    if(userGroupData!==undefined){
        userGroup = userGroupData.user_group; 
    }
    let ENDPOINT = '';
    if(request.data!==undefined){     
      let column = request.data.column;  
      let shiftId = request.data.shiftId ? request.data.shiftId : 0; 
      let affiliateId = request.data.affiliateId; 
      if(userGroup===LOGIN_AFFILIATE_GROUP){
        ENDPOINT = URL_BASE_API+'affiliate/client-category_v2/?column='+column;
        if(request.data.page !== undefined){
          ENDPOINT = ENDPOINT+"&page="+request.data.page
        }
      }else if(userGroup===LOGIN_CLIENT_GROUP){
        ENDPOINT = URL_BASE_API+'affiliate/client-category_v2/?column='+column+'&affiliate='+affiliateId;
      }else{
        if(column){
          ENDPOINT = URL_BASE_API+'super-admin/client-category/?column='+column;
        }
      }  
      if(shiftId) ENDPOINT += '&shift_id='+shiftId; 
      
    }else{
      if(userGroup===LOGIN_AFFILIATE_GROUP){
        ENDPOINT = URL_BASE_API+'affiliate/client-category_v2/';
      }else if(userGroup===LOGIN_CLIENT_GROUP){
          ENDPOINT = URL_BASE_API+'affiliate/client-category/';
      }else{
        ENDPOINT = URL_BASE_API+'super-admin/client-category/';
      }
    }   

    return service.get(ENDPOINT);
    
};


export const clientCategoryAdd = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/client-category_v2/';
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/client-category/';
  }
  return service.post(ENDPOINT,request.data);
};

export const clientCategoryEdit = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';
  let clientCategoryId = request.data;
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/client-category_v2/'+clientCategoryId;
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/client-category/'+clientCategoryId;
  }
  return service.get(ENDPOINT);  
};


export const clientCategoryUpdate = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';

  let clientCategoryId = request.data.id;
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/client-category_v2/'+clientCategoryId;
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/client-category/'+clientCategoryId;
  }
  return service.put(ENDPOINT,request.data);  
};

export const clientCategoryDelete = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/client-category_v2/'+request.data;
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/client-category/'+request.data;
  }
  return service.delete(ENDPOINT);   
};  